import { configureStore } from '@reduxjs/toolkit';
import projectReducer from '../Pages/CommunityOnBoarding/ProjectSlice';
import scenariosReducer from '../Pages/Scenario/ScenarioSlice';
import userReducer from '../Pages/UserManagement/UserSlice';

import appReducer from '../AppSlice';
import calendarReducer from '../store/slices/calendar';
import customerReducer from '../store/slices/customer';
import { default as chatReducer, default as userReducerBerry } from '../store/slices/user';
// Import the shiftNotes reducer
import homeTilesReducer from '../slices/HomeTilesSlices';
import servicesReducer from '../slices/selectedServiceSlice';

import eventCalendarReducer from '../slices/NdisSlices/calenderEvents/CalenderEventsSlice';
import carePlanInfoReducer from '../slices/NdisSlices/carePlanInfo/CarePlanInfoSlice';
import clockInOutReducer from '../slices/NdisSlices/clockInOut/ClockInOutSlice';
import invoiceReducer from '../slices/NdisSlices/finance/InvoiceSlice';
import managersListReducer from '../slices/NdisSlices/managersList/ManagersListSlice';
import manageServicesReducer from '../slices/NdisSlices/platformAdmin/ManageServicesSlice';
import membersReviewReducer from '../slices/NdisSlices/platformAdmin/MembersReviewFormSlice';
import createStaffMembersReducer from '../slices/NdisSlices/staffManagement/createStaffMembersSlice';

import manageRolesReducer from '../slices/NdisSlices/platformAdmin/ManageRolesSlice';
import platformAdminReducer from '../slices/NdisSlices/platformAdmin/PlatformAdminSlice';
import shiftNotesReducer from '../slices/NdisSlices/shiftDetails/shiftNotesSlice';
import profileSettingsReducer from '../slices/ProfileSettingsSlice';
import loginSignupReducer from '../store/slices/loginSignupSlice';
import toastReducer from '../store/slices/toastSlice';
//report all
import clientIncidentReducer from '../slices/NdisSlices/reportAllForms/clientIncidentSlice';
import complaintAndFeedbackReducer from '../slices/NdisSlices/reportAllForms/complaintAndFeedbackSlice';
import dataBreachReducer from '../slices/NdisSlices/reportAllForms/dataBreachSlice';
import employeeIncidentReducer from '../slices/NdisSlices/reportAllForms/employeeIncidentSlice';
import equipmentIncidentReducer from '../slices/NdisSlices/reportAllForms/equipmentIncidentSlice';
import maintenanceRequestReducer from '../slices/NdisSlices/reportAllForms/maintenanceRequestSlice';
import medicationIncidentReducer from '../slices/NdisSlices/reportAllForms/medicationIncidentSlice';
import outreachFormReducer from '../slices/NdisSlices/reportAllForms/outreachFormSlice';
import restrictivePracticesIncidentReducer from '../slices/NdisSlices/reportAllForms/restrictivePracticesIncidentSlice';
//
import organizationReducer from '../slices/NdisSlices/carporateServices/organizationSlice';
import clientManagementReducer from '../slices/NdisSlices/carporateServices/clientsManagementSlice';
import feedbackAndManagementListReducer from '../slices/NdisSlices/carporateServices/feedbackAndManagementListSlice';
import incidentsListReducer from '../slices/NdisSlices/carporateServices/IncidentsListSlice';
//
import peopleReducer from '../slices/payrolslices/PeopleSlice';
import documentTemplateReducer from '../slices/payrolslices/documentTemplateSlice';

//
import incomeExpensesReducer from '../slices/incomeExpenses/IncomeExpensesSlice';
//
import fundManagementInvestmentReducer from '../slices/fundManagementInvestment/fundmanagementInvestmentSlice';
import simulationDashboardReducer from '../slices/fundManagementInvestment/simulationDashboardSlice';
import fundManagementReportsSliceReducer from '../slices/fundManagementInvestment/fundManagementReportsSlice';
import fundManagementConfigurationReducer from '../slices/fundManagementInvestment/fundManagementConfigurationSlice';

export const store = configureStore({
  reducer: {
    toast: toastReducer,

    customer: customerReducer,
    user: userReducerBerry,
    chat: chatReducer,
    calendar: calendarReducer,
    usermanagement: userReducer,
    projectmanagement: projectReducer,
    scenarioData: scenariosReducer,

    appData: appReducer,

    // Add shiftNotes reducer here
    calendarEvents: eventCalendarReducer,
    shiftNotes: shiftNotesReducer,
    platformAdmin: platformAdminReducer,
    homeTilesServices: homeTilesReducer,
    serviceSelected: servicesReducer,
    loginSignup: loginSignupReducer,
    membersReview: membersReviewReducer,
    clockInOut: clockInOutReducer,
    createStaffMembers: createStaffMembersReducer,
    manageServices: manageServicesReducer,
    manageRoles: manageRolesReducer,
    managersList: managersListReducer,
    invoice: invoiceReducer,
    carePlanInfo: carePlanInfoReducer,
    profileSettings: profileSettingsReducer,

    //report all
    complaintAndFeedback: complaintAndFeedbackReducer,
    maintenanceRequest: maintenanceRequestReducer,
    outreachForm: outreachFormReducer,
    clientIncident: clientIncidentReducer,
    dataBreach: dataBreachReducer,
    employeeIncident: employeeIncidentReducer,
    equipmentIncident: equipmentIncidentReducer,
    medicationIncident: medicationIncidentReducer,
    restrictivePracticesIncident: restrictivePracticesIncidentReducer,
    //ndis corporate services
    organization: organizationReducer,
    clientManagement: clientManagementReducer,
    feedbackAndManagementList: feedbackAndManagementListReducer,
    incidentsList: incidentsListReducer,

    ///
    people: peopleReducer,
    documentTemplate: documentTemplateReducer,
    // income expenses
    incomeExpenses: incomeExpensesReducer,

    //fund management investment
    fundManagementInvestment: fundManagementInvestmentReducer,
    simulationDashboard: simulationDashboardReducer,
    fundManagementReports: fundManagementReportsSliceReducer,
    fundManagementConfiguration: fundManagementConfigurationReducer
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
